// @flow

export const Primary: 'primary' = 'primary';
export const White: 'white' = 'white';
export const Grey: 'grey' = 'grey';
